<template lang="pug">
.TheToasterItem.toaster-item(
  @click="onLinkClick"
  :class="`toaster-item--${type}`"
  @mouseenter="onMouseEnter"
  @mouseleave="onMouseLeave"
  ref="container"
)
  .toaster-item__left-col
    SolidCheckCircleIcon(v-if="isSuccessType").svg-icon.check-circle-icon
    SolidExclamationCircleIcon(v-if="isErrorType").svg-icon.exclamation-circle-icon
    SolidExclamationTriangleIcon(v-if="isWarningType").svg-icon.exclamation-triangle-icon
    SolidInfoCircleIcon(v-if="isInfoType").svg-icon.info-circle-icon
  .toaster-item__content
    .toaster-item__text
      span(
        v-html="$_text",
        v-improve-links,
      )
    .toaster-item__more-text(
      v-if="$_moreText",
      v-html="$_moreText",
      v-improve-links,
    )
  .toaster-item__right-col
    button.toaster-item__close-button(type="button" role="button" @click="onClick")
      SolidTimesIcon.svg-icon.times-icon
</template>

<script>
import SolidTimesIcon from 'images/svg-icons/fa-close.svg';
import SolidCheckCircleIcon from 'images/svg-icons/fa-circle-check.svg';
import SolidExclamationCircleIcon from 'images/svg-icons/fa-circle-exclamation.svg';
import SolidExclamationTriangleIcon from 'images/svg-icons/fa-triangle-exclamation.svg';
import SolidInfoCircleIcon from 'images/svg-icons/fa-circle-info.svg';

export default {
  name: 'TheToasterItem',
  components: {
    SolidTimesIcon,
    SolidCheckCircleIcon,
    SolidExclamationCircleIcon,
    SolidExclamationTriangleIcon,
    SolidInfoCircleIcon,
  },
  props: {
    text: [String, Array],
    type: {
      validator: value => ['success', 'error', 'info', 'warning'].includes(value),
      default: 'success',
    },
    timeout: {
      default: 6000,
      validator: val => Number(val) >= 0,
    },
    onMount: Function,
    onUserClose: Function,
  },
  computed: {
    isInfoType() {
      return this.type === 'info';
    },
    isSuccessType() {
      return this.type === 'success';
    },
    isErrorType() {
      return this.type === 'error';
    },
    isWarningType() {
      return this.type === 'warning';
    },
    $_text() {
      if (Array.isArray(this.text)) {
        return this.text[0];
      }
      return this.text;
    },
    $_moreText() {
      if (Array.isArray(this.text)) {
        return this.text[1];
      }
      return '';
    },
  },
  destroyed() {
    this.stopTimeout();
  },
  mounted() {
    if (this.timeout) this.setHideTimeout();
    if (this.onMount) this.onMount(this.$refs.container);
  },
  methods: {
    onClick() {
      if (typeof this.onUserClose === 'function') this.onUserClose();
      this.hide();
    },
    hide() {
      this.stopTimeout();
      this.$emit('hide');
    },
    stopTimeout() {
      clearTimeout(this.hideTimeoutId);
    },
    setHideTimeout() {
      this.startTime = Date.now();
      const timeout = this.timeout - this.passedTime;
      this.hideTimeoutId = setTimeout(this.hide, timeout);
    },
    onMouseEnter() {
      if (!this.timeout) return;
      this.stopTimeout();
      this.passedTime += Date.now() - this.startTime;
    },
    onMouseLeave() {
      if (!this.timeout) return;
      this.setHideTimeout();
    },
    onLinkClick(e) {
      if (e?.target?.tagName?.toLowerCase() === 'a') {
        this.onClick();
      }
    },
  },
  staticData: {
    passedTime: 0,
  },
};
</script>

<style lang="sass" scoped>
  @import '~Styles/_variables'
  .toaster-item
    margin-bottom: 15px
    position: relative
    overflow: hidden
    z-index: 2
    pointer-events: auto
    max-width: 100%
    width: 288px
    padding: 16px
    box-shadow: 0 2px 6px 02px rgba(0,0,0,0.15), 0 1px 2px 0 rgba(0,0,0,.30)
    display: flex
    border-left: 3px solid
    @media screen and (max-width: 576px)
      width: calc(100vw - 16px)
    &__content
      margin: 0 16px
      flex: 1
      color: $bunker !important
      font-size: 14px
      font-weight: 500
      ::v-deep a
        text-decoration: underline
        border: none
        font-size: inherit
    &__more-text
      font-weight: 400
    &__left-col
      svg
        width: 20px
        height: 20px
    &__right-col
      margin-left: 16px
    &--error
      background-color: $light_red
      border-color: $support_red
      ::v-deep a
        color: $support_red !important
      & .toaster-item__left-col .svg-icon
        fill: $support_red
    &--warning
      background-color: $light_yellow
      border-color: $support_yellow
      width: 430px
      ::v-deep a
        color: $secondary !important
      & .toaster-item__left-col .svg-icon
        fill: $support_yellow
    &--success
      background-color: $light_green
      border-color: $shamrock
      ::v-deep a
        color: $secondary !important
      & .toaster-item__left-col .svg-icon
        fill: $shamrock
    &--info
      background-color: $light_blue
      border-color: $shakespeare
      ::v-deep a
        color: $shakespeare !important
      & .toaster-item__left-col .svg-icon
        fill: $shakespeare
</style>
